export const DASHBOARD_URI = '/dashboard';
export const LOGIN_URI = '/login';
export const LOGOUT_URI = '/logout';
export const ROOT = '/';
export const CPAAS_REPORTS_URI = '/analytics-console-user-interface';
export const CONVERSATION_STUDIO_URI = '/virtual-agents';
export const CONVERSATION_HUB_URI = '/conversation-hub';
export const disallowBookmarkingForPaths = [ROOT, LOGIN_URI, LOGOUT_URI];
